<template>
	<div id="header" class="header-cont">
	  <div class="top-view">
		<div class="title" @click="handleTitleClick()">
			<img class="logo" src="../assets/images/logo.png" alt=""></img>
			樂雅健康管理系统
		</div>
		<div class="nowTime" @click="handleTimeClick">{{ currentTime }}</div>
	  </div>
	</div>
  </template>

  <style scoped lang="scss">
  #header {
	z-index: 99;
	padding: 15px 30px;
  position: fixed;
  top: 0;
  width: 100%;

	.top-view {
		display: flex;
		justify-content: space-between;

		.title {
			align-items: center;
			display: flex;
			font-weight: 500;
			font-size: 30px;
			color: #FFFFFF;
			line-height: 32px;
			color: #FFFFFF;

			.logo {
				width: 44px;
				height: 38px;
				margin-right: 9px;
			}
		}
		.nowTime {
			font-weight: 400;
			font-size: 18px;
			color: #FFFFFF;
			line-height: 26px;
      height: 26px;
		}
	}
  }
  </style>

  <script>
import { logout } from "@api/index";


  export default {
	name: "Header",
	props: {},
	data: function() {
	  return {
      centerDialogVisible : false,
		  currentTime : '',
		  clickCount: 0,
		  clickTimer: null,
		  titleClickCount: 0,
		  titleClickTimer: null,
	  };
	},
	methods: {
		handleTitleClick() {
			this.titleClickCount++;

			// 清除之前的定时器
			if (this.titleClickTimer) {
				clearTimeout(this.titleClickTimer);
			}

			// 如果点击次数达到5次，触发退出
			if (this.titleClickCount >= 5) {
				this.logout();
				this.titleClickCount = 0;
				return;
			}

			// 2秒内没有继续点击，重置计数
			this.titleClickTimer = setTimeout(() => {
				this.titleClickCount = 0;
			}, 2000);
		},
		logout() {
			this.$dialog.confirm({
				mes: "确认退出登录?",
				opts: () => {
					logout().then(res => {
						this.$store.commit("LOGOUT");
						location.href = location.origin;
					})
					.catch(err => {
						console.log(err);
					});
				}
			});
		},
		handleTimeClick() {
			this.clickCount++;

			// 清除之前的定时器
			if (this.clickTimer) {
				clearTimeout(this.clickTimer);
			}

			// 如果点击次数达到5次，切换全屏
			if (this.clickCount >= 5) {
				this.toggleFullScreen();
				this.clickCount = 0;
				return;
			}

			// 2秒内没有继续点击，重置计数
			this.clickTimer = setTimeout(() => {
				this.clickCount = 0;
			}, 2000);
		},
		toggleFullScreen() {
			if (!document.fullscreenElement) {
				// 进入全屏
				if (document.documentElement.requestFullscreen) {
					document.documentElement.requestFullscreen();
				} else if (document.documentElement.webkitRequestFullscreen) {
					document.documentElement.webkitRequestFullscreen();
				} else if (document.documentElement.mozRequestFullScreen) {
					document.documentElement.mozRequestFullScreen();
				} else if (document.documentElement.msRequestFullscreen) {
					document.documentElement.msRequestFullscreen();
				}
			} else {
				// 退出全屏
				if (document.exitFullscreen) {
					document.exitFullscreen();
				} else if (document.webkitExitFullscreen) {
					document.webkitExitFullscreen();
				} else if (document.mozCancelFullScreen) {
					document.mozCancelFullScreen();
				} else if (document.msExitFullscreen) {
					document.msExitFullscreen();
				}
			}
		},
		updateCurrentTime() {
			const now = new Date();
			const year = now.getFullYear();
			const month = String(now.getMonth() + 1).padStart(2, '0');
			const day = String(now.getDate()).padStart(2, '0');
			const hours = String(now.getHours()).padStart(2, '0');
			const minutes = String(now.getMinutes()).padStart(2, '0');
			const seconds = String(now.getSeconds()).padStart(2, '0');
			this.currentTime = `${year}年${month}月${day}日 ${hours}:${minutes}:${seconds}`;
		}
	},
	mounted() {
		this.updateCurrentTime();
		setInterval(this.updateCurrentTime, 1000);
	}
  };
  </script>
